import { atom } from "jotai";

/**
 * The cost type configuration served by `GET claim-cost-types`.
 * `status` is "idle" until a fetch starts, so concurrent consumers
 * trigger a single request; "error" after a failed fetch until a retry.
 */
export const claimCostTypesAtom = atom({ status: "idle", data: null });
